import React, {useState, useEffect} from 'react';
import { StyleSheet } from 'react-native';

interface DeactivateUserPopupProps {
    onClose: () => void;
    onSave: () => void;
    canBeDeactivated: boolean;
}


const DeactivateUserPopup: React.FC<DeactivateUserPopupProps> = ({ onClose, onSave, canBeDeactivated }) => {
    const handleSaveChanges = () => {
        onSave();
    };
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);

      const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1001,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
        input: {
            shadowOpacity: 0,
            borderRadius: 8,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#D0D5DD',
            height: 35
        }
    });
    

    return (
        <div style={styles.popup} className='popup-shadow ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-between'>
                <h5>Deactivate User</h5>
            </div>
            <div className='px-3 pb-3 d-flex flex-column'>
                {
                    !canBeDeactivated ?
                        <small className='mt-3'>
                            You cannot deactivate this user while it still has orders and tabs in process. <br />
                            Transfer the orders to another Waiter or close the orders with a payment method.
                        </small>
                        :
                        <small className='mt-3'>
                            Confirm that you want to deactivate this user.
                        </small>
                }
                <div className='d-flex mt-4 align-items-center justify-content-center' style={{ gap: '10px', flexWrap: 'nowrap' }}>
                    {
                        !canBeDeactivated ?
                            <button className='blue-outline-btn align-items-center d-flex w-100' onClick={onClose} style={{ borderRadius: 8, maxWidth: '40%' }}>
                                Close
                            </button>
                            :
                            <>
                                <button className='blue-outline-btn align-items-center d-flex w-100' onClick={onClose} style={{ borderRadius: 8 }}>
                                    Cancel
                                </button>
                                <button className='blue-filled-btn align-items-center d-flex w-100' onClick={handleSaveChanges} style={{ borderRadius: 8 }}>
                                    Confirm
                                </button>
                            </>
                    }
                </div>
            </div>
        </div>
    );
};



export default DeactivateUserPopup;

